<template>
    <div>
        <button class="btn btn-primary" @click="openOffcanvas">
            <i class="fa-solid fa-bars"></i>
        </button>
        <!-- Overlay -->
        <div v-if="isOffcanvasOpen" class="overlay-1" @click="closeOffcanvas"></div>
        <div class="offcanvas-1 offcanvas-start d-flex flex-column h-100 justify-content-between" tabindex="-1"
            :style="{ visibility: isOffcanvasOpen ? 'visible' : 'hidden' }" :class="{ 'show': isOffcanvasOpen }">
            <!-- Static Menu -->
            <ul v-if="!isNavigating" class="list-group mx-2">
                <div class="offcanvas-header  m-2 d-flex align-items-start pt-2 px-1 justify-content-between">
                    <li v-if="isLogin" class="">
                        <div class="d-flex align-items-center justify-content-between gap-2">
                            <div class="profile-img">
                                <img :src="getImagePath(userData?.profilePicture)"
                                    class="img-fluid user-img object-fit-cover" @error="handleImageError" />
                            </div>
                            <div>
                                <span class="user-name d-block"> {{ userData?.userName }}</span>
                                <span class="user-email d-block"> {{ userData?.email }}</span>
                            </div>
                        </div>
                    </li>
                    <router-link :to="{ path: `/${$i18n.locale}/` }" v-if="!isLogin" aria-label="ebtkar logo"
                        class="navbar-brand">
                        <img src="../../assets/images/icon-logo.svg" width="183" height="150" alt="Ebtkar Logo"
                            class="img-fluid" style="width:60px" />
                    </router-link>
                    <button type="button" class="btn-close mt-3" @click="closeOffcanvas"></button>
                </div>
                <div>
                    <div class="d-flex  align-items-center justify-content-start gap-4 mx-2 mt-0 mb-3 actions-section"
                        v-if="!isLogin">
                        <div class="nav-item mb-0 mt-lg-0 flex-shrink-0">
                            <router-link class="d-inline-flex gap-2 align-items-center"
                                :to="{ path: `/${$i18n.locale}/login` }">
                                <i class="fa-solid fa-right-to-bracket" style="color:#2EA2CE;font-size:16px"></i>
                                {{ $t("login") }}
                            </router-link>
                        </div>
                        <div class="nav-item mb-0 mt-lg-0 flex-shrink-0">
                            <router-link class="d-inline-flex gap-2 align-items-center"
                                :to="{ path: `/${$i18n.locale}/accounts` }">
                                <i class="fa-solid fa-user-plus" style="color:#2EA2CE;font-size:16px"></i>
                                {{ $t("register") }}
                            </router-link>
                        </div>
                    </div>
                    <div class="d-flex  align-items-center justify-content-start gap-4 mx-2 mb-3 actions-section"
                        v-if="isLogin">
                        <div>
                            <a class="d-inline-flex gap-2 align-items-center" href="#">
                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17"
                                    fill="none" class="first">
                                    <path
                                        d="M0.944444 9.44444H6.61111C6.86159 9.44444 7.10182 9.34494 7.27893 9.16782C7.45605 8.9907 7.55556 8.75048 7.55556 8.5V0.944444C7.55556 0.693962 7.45605 0.453739 7.27893 0.276621C7.10182 0.0995036 6.86159 0 6.61111 0H0.944444C0.693962 0 0.453739 0.0995036 0.276621 0.276621C0.0995036 0.453739 0 0.693962 0 0.944444V8.5C0 8.75048 0.0995036 8.9907 0.276621 9.16782C0.453739 9.34494 0.693962 9.44444 0.944444 9.44444ZM0 16.0556C0 16.306 0.0995036 16.5463 0.276621 16.7234C0.453739 16.9005 0.693962 17 0.944444 17H6.61111C6.86159 17 7.10182 16.9005 7.27893 16.7234C7.45605 16.5463 7.55556 16.306 7.55556 16.0556V12.2778C7.55556 12.0273 7.45605 11.7871 7.27893 11.61C7.10182 11.4328 6.86159 11.3333 6.61111 11.3333H0.944444C0.693962 11.3333 0.453739 11.4328 0.276621 11.61C0.0995036 11.7871 0 12.0273 0 12.2778V16.0556ZM9.44444 16.0556C9.44444 16.306 9.54395 16.5463 9.72107 16.7234C9.89818 16.9005 10.1384 17 10.3889 17H16.0556C16.306 17 16.5463 16.9005 16.7234 16.7234C16.9005 16.5463 17 16.306 17 16.0556V9.44444C17 9.19396 16.9005 8.95374 16.7234 8.77662C16.5463 8.5995 16.306 8.5 16.0556 8.5H10.3889C10.1384 8.5 9.89818 8.5995 9.72107 8.77662C9.54395 8.95374 9.44444 9.19396 9.44444 9.44444V16.0556ZM10.3889 6.61111H16.0556C16.306 6.61111 16.5463 6.51161 16.7234 6.33449C16.9005 6.15737 17 5.91715 17 5.66667V0.944444C17 0.693962 16.9005 0.453739 16.7234 0.276621C16.5463 0.0995036 16.306 0 16.0556 0H10.3889C10.1384 0 9.89818 0.0995036 9.72107 0.276621C9.54395 0.453739 9.44444 0.693962 9.44444 0.944444V5.66667C9.44444 5.91715 9.54395 6.15737 9.72107 6.33449C9.89818 6.51161 10.1384 6.61111 10.3889 6.61111Z"
                                        fill="#2EA2CE" />
                                </svg>
                                <span>{{ $t('dashboard') }}</span>
                            </a>
                        </div>
                        <div>
                            <a class="d-inline-flex gap-2 align-items-center" href="#">
                                <i class="fa-solid fa-gear" style="color:#2EA2CE"></i>
                                <span>{{ $t('settings') }}</span>
                            </a>
                        </div>
                    </div>
                </div>

                <li class="nav-item dropdown px-2 px-lg-1">
                    <router-link class="nav-link exact" :to="{ path: `/${$i18n.locale}` }" role="button">
                        {{ $t("home") }}
                    </router-link>
                </li>
                <li @click="isNavigating = true" class="nav-item " style="cursor: pointer">
                    <button
                        class="nav-link d-flex justify-content-between align-items-center w-100 px-2 border-0 bg-transparent">
                        {{ $t("programs") }}
                        <i class="fa-solid fa-angle-left"></i>
                    </button>
                </li>
                <li class="nav-item dropdown px-2 exact">
                    <router-link class="nav-link exact" :to="{ path: `/${$i18n.locale}/blog` }" role="button">
                        {{ $t("blog") }}
                    </router-link>
                </li>
                <li class="nav-item dropdown px-2">
                    <router-link class="nav-link exact" :to="{ path: `/${$i18n.locale}/about` }" role="button">
                        {{ $t("about_us") }}
                    </router-link>
                </li>
                <li class="nav-item dropdown px-2">
                    <router-link class="nav-link exact" :to="{ path: `/${$i18n.locale}/contact` }" role="button">
                        {{ $t("contact_us") }}
                    </router-link>
                </li>
                <li class="nav-item dropdown px-2 mb-3">
                    <router-link class="nav-link exact" :to="{ path: `/${$i18n.locale}/services` }" role="button">
                        {{ $t("services") }}
                    </router-link>
                </li>
                <li class="nav-item dropdown px-2 mb-3">
                    <router-link class="nav-link exact" :to="{ path: `/${$i18n.locale}/join-us` }" role="button">
                        {{ $t("join_us") }}
                    </router-link>
                </li>
                <!----------------------------->
            </ul>

            <!-- Dynamic Navigation Menu -->
            <div v-else class="offcanvas-body p-2 mt-2">
                <div class="offcanvas-header">
                    <button class="btn back mb-2" v-if="!showCourses" @click="isNavigating = false">
                        {{ $t('back') }} <i class="fa-solid fa-angle-left mx-1"></i>
                    </button>
                </div>
                <!-- Categories List -->
                <div v-if="!showCourses">
                    <ul class="list-group">
                        <li v-for="item in categories" :key="item.id"
                            class="list-group-item list-group-item-action border-0 d-flex justify-content-between align-items-center"
                            @click="coursesOnHover(item.id, item.name)">
                            {{ item.name }}
                            <i class="fa-solid fa-angle-left"></i>
                        </li>
                    </ul>
                </div>

                <!-- Accordion View -->
                <div v-if="showCourses">
                    <button class="btn back mb-3" @click="backToCategories">
                        {{ $t('back') }} <i class="fa-solid fa-angle-left mx-1"></i>
                    </button>

                    <!-- <h5 class="mb-3 text-info pb-3 border-info border-bottom-1" v-if="selectedCategoryName">{{ selectedCategoryName }}</h5> -->
                    <div class="accordion" id="accordionCourses">
                        <!-- Recorded -->
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingRecorded">
                                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseRecorded" aria-expanded="true"
                                    aria-controls="collapseRecorded">
                                    {{ $t('menu.course4') }}
                                </button>
                            </h2>
                            <div id="collapseRecorded" class="accordion-collapse collapse show"
                                aria-labelledby="headingRecorded" data-bs-parent="#accordionCourses">
                                <div class="accordion-body">
                                    <ul v-if="recordedCourses.length">
                                        <li v-for="course in recordedCourses" :key="course.id">
                                            {{ course.name }}
                                        </li>
                                    </ul>
                                    <div v-else>
                                        {{ $t('no-course-here') }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Online -->
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingOnline">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOnline" aria-expanded="false"
                                    aria-controls="collapseOnline">
                                    {{ $t('menu.course5') }}
                                </button>
                            </h2>
                            <div id="collapseOnline" class="accordion-collapse collapse" aria-labelledby="headingOnline"
                                data-bs-parent="#accordionCourses">
                                <div class="accordion-body">
                                    <ul v-if="onlineCourses.length">
                                        <li v-for="course in onlineCourses" :key="course.id">
                                            {{ course.name }}
                                        </li>
                                    </ul>
                                    <div v-else>
                                        {{ $t('no-course-here') }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Offline -->
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingOffline">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOffline" aria-expanded="false"
                                    aria-controls="collapseOffline">
                                    {{ $t('menu.course6') }}
                                </button>
                            </h2>
                            <div id="collapseOffline" class="accordion-collapse collapse"
                                aria-labelledby="headingOffline" data-bs-parent="#accordionCourses">
                                <div class="accordion-body">
                                    <ul v-if="offlineCourses.length">
                                        <li v-for="course in offlineCourses" :key="course.id">
                                            {{ course.name }}
                                        </li>
                                    </ul>
                                    <div v-else>
                                        {{ $t('no-course-here') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-----Social Links--------------------->
            <div class="py-2 special-login">
                <div class="d-lg-flex flex-row gap-5 py-3">
                    <a href="#" aria-label="phone" target="_blank" class="social" exact>
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                            <path
                                d="M5.58676 1.91428L6.51063 1.63641C7.01674 1.48379 7.56108 1.52053 8.04209 1.73977C8.52309 1.959 8.90791 2.34576 9.12471 2.82787L9.8388 4.41595C10.0252 4.83063 10.0771 5.29326 9.98724 5.73893C9.89737 6.18461 9.67022 6.59097 9.33767 6.90099L8.15413 8.00378C8.11956 8.036 8.09765 8.07953 8.09238 8.12649C8.05755 8.44078 8.27051 9.05274 8.76213 9.90378C9.11838 10.5221 9.44217 10.9567 9.71688 11.1997C9.90926 11.3699 10.0145 11.4064 10.0597 11.3937L11.6509 10.9068C12.0855 10.7739 12.5507 10.7803 12.9815 10.9251C13.4122 11.0699 13.7868 11.3459 14.0528 11.7143L15.0662 13.1203C15.3747 13.5478 15.5176 14.0727 15.4684 14.5976C15.4191 15.1224 15.1812 15.6116 14.7986 15.9743L14.0964 16.6393C13.7241 16.9918 13.2669 17.2419 12.7692 17.3653C12.2716 17.4886 11.7505 17.481 11.2567 17.3431C9.07642 16.7343 7.1218 14.8944 5.37063 11.8616C3.61788 8.82474 3.00196 6.20907 3.57038 4.01378C3.69798 3.52005 3.95061 3.06751 4.30392 2.69977C4.65723 2.33204 5.09852 2.06152 5.58676 1.91428ZM5.93034 3.05191C5.63733 3.14003 5.37197 3.30213 5.15981 3.52261C4.94766 3.74308 4.79588 4.01448 4.71909 4.31066C4.24251 6.15682 4.78796 8.47562 6.3998 11.2678C8.01005 14.0561 9.74301 15.6877 11.5773 16.1999C11.8736 16.2825 12.1863 16.287 12.4848 16.213C12.7834 16.1389 13.0577 15.9887 13.281 15.7772L13.9824 15.1122C14.1564 14.9473 14.2647 14.7249 14.2871 14.4863C14.3095 14.2477 14.2446 14.009 14.1043 13.8146L13.091 12.4094C12.97 12.2417 12.7997 12.1161 12.6037 12.0503C12.4078 11.9844 12.1961 11.9815 11.9985 12.0421L10.4033 12.5305C9.47701 12.806 8.63705 12.0611 7.73455 10.4975C7.12496 9.44462 6.84155 8.6292 6.9128 7.99507C6.94921 7.66574 7.1028 7.36174 7.34426 7.13532L8.5278 6.03253C8.67889 5.89153 8.78205 5.70677 8.8228 5.50416C8.86355 5.30155 8.83984 5.09127 8.75501 4.90282L8.04171 3.31474C7.94315 3.0956 7.76822 2.91981 7.54956 2.82017C7.33091 2.72053 7.08347 2.70385 6.85342 2.77324L5.93034 3.05191Z"
                                fill="#206387" />
                        </svg>
                    </a>
                    <a href="#" aria-label="whatsapp" target="_blank" class="social">
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                            <path
                                d="M4.15629 3.16675H14.8438C15.501 3.16671 16.1333 3.41814 16.611 3.86949C17.0887 4.32083 17.3755 4.93786 17.4127 5.594L17.4167 5.73966V13.2605C17.4167 13.9177 17.1653 14.55 16.714 15.0277C16.2626 15.5054 15.6456 15.7923 14.9895 15.8295L14.8438 15.8334H4.15629C3.4991 15.8335 2.8668 15.582 2.38911 15.1307C1.91141 14.6793 1.62454 14.0623 1.58733 13.4062L1.58337 13.2605V5.73966C1.58333 5.08247 1.83477 4.45018 2.28611 3.97248C2.73746 3.49479 3.35449 3.20791 4.01062 3.17071L4.15629 3.16675ZM16.2292 7.42037L9.77712 10.8166C9.70427 10.8551 9.6242 10.878 9.54202 10.8839C9.45983 10.8897 9.37733 10.8784 9.29975 10.8507L9.22375 10.8174L2.77087 7.42116V13.2605C2.77089 13.6082 2.90163 13.9432 3.13716 14.1989C3.37269 14.4547 3.69578 14.6126 4.04229 14.6412L4.15629 14.6459H14.8438C15.1916 14.6459 15.5267 14.515 15.7825 14.2793C16.0383 14.0436 16.196 13.7204 16.2245 13.3737L16.2292 13.2605V7.42037ZM14.8438 4.35425H4.15629C3.8086 4.35426 3.47362 4.48501 3.21786 4.72054C2.96209 4.95606 2.80423 5.27915 2.77562 5.62566L2.77087 5.73966V6.07929L9.50004 9.62121L16.2292 6.0785V5.73966C16.2292 5.39185 16.0983 5.05676 15.8626 4.80098C15.6269 4.54519 15.3037 4.38742 14.957 4.359L14.8438 4.35425Z"
                                fill="#206387" />
                        </svg>
                    </a>
                    <a target="_blank" class="social" aria-label="whatsapp" href="#">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                            <path
                                d="M11.0367 1.83331C6.03165 1.83331 1.95248 5.91247 1.95248 10.9175C1.95248 12.5216 2.37415 14.08 3.16248 15.455L1.87915 20.1666L6.69165 18.9016C8.02082 19.6258 9.51498 20.0108 11.0367 20.0108C16.0417 20.0108 20.1208 15.9316 20.1208 10.9266C20.1208 8.49747 19.1767 6.21497 17.4625 4.50081C16.6221 3.65191 15.6211 2.97884 14.5178 2.52085C13.4146 2.06287 12.2312 1.82915 11.0367 1.83331ZM11.0458 3.36414C13.0625 3.36414 14.9508 4.15247 16.3808 5.58247C17.0826 6.28405 17.639 7.11726 18.0181 8.03434C18.3972 8.95141 18.5916 9.9343 18.59 10.9266C18.59 15.0883 15.1983 18.4708 11.0367 18.4708C9.67998 18.4708 8.35082 18.1133 7.19582 17.4166L6.92082 17.2608L4.06082 18.0125L4.82165 15.2258L4.63832 14.9325C3.8811 13.7304 3.48058 12.3381 3.48332 10.9175C3.49248 6.75581 6.87498 3.36414 11.0458 3.36414ZM7.81915 6.71914C7.67248 6.71914 7.42498 6.77414 7.21415 7.00331C7.01248 7.23247 6.41665 7.79164 6.41665 8.90081C6.41665 10.0191 7.23248 11.0916 7.33332 11.2475C7.46165 11.4033 8.94665 13.695 11.2292 14.6666C11.77 14.9141 12.1917 15.0516 12.5217 15.1525C13.0625 15.3266 13.5575 15.2991 13.9517 15.2441C14.3917 15.18 15.29 14.6941 15.4825 14.1625C15.675 13.6308 15.675 13.1816 15.62 13.0808C15.5558 12.9891 15.4092 12.9341 15.18 12.8333C14.9508 12.705 13.8325 12.155 13.6308 12.0816C13.42 12.0083 13.2917 11.9716 13.1175 12.1916C12.9708 12.4208 12.5308 12.9341 12.4025 13.0808C12.265 13.2366 12.1367 13.255 11.9167 13.145C11.6783 13.0258 10.945 12.7875 10.0833 12.0175C9.40498 11.4125 8.95582 10.67 8.81832 10.4408C8.70832 10.2208 8.80915 10.0833 8.91915 9.98247C9.01998 9.88164 9.16665 9.71664 9.25832 9.57914C9.37748 9.45081 9.41415 9.34997 9.48748 9.20331C9.56082 9.04747 9.52415 8.91914 9.46915 8.80914C9.41415 8.70831 8.95582 7.57164 8.76332 7.12247C8.57998 6.68247 8.39665 6.73747 8.24998 6.72831C8.12165 6.72831 7.97498 6.71914 7.81915 6.71914Z"
                                fill="#206387" />
                        </svg>
                    </a>
                </div>
            </div>
            <!--------------------------------->
        </div>
    </div>
</template>

<script>
import apiClient from '@/Services/apiClient';
import { useAuthStore } from "@/store/authStore";

export default {
    props: ['isLogin', 'userData','categories'],
    setup() {
        return { authStore: useAuthStore() }
    },
    data() {
        return {
            isOffcanvasOpen: false,
            isNavigating: false,
            courseType: null,
            recordedCourses: [],
            onlineCourses: [],
            offlineCourses: [],
            courses: [],
            showPrograms: false,
            showCourses: false,
            selectedCategoryName: '',
            history: [],
            currentItems: [],
            currentTitle: '',
            AsesstsUrl: this.$store.state.AssetUrl
        };
    },
    computed: {
        // categories() {
        //     return this.$store.getters.categories
        // }
    },

    methods: {
        getImagePath(path) {
            if (path) {
                if (path.includes('http')) {
                    return path;
                }
                return `${this.AsesstsUrl}${path}`
            }
        },
        Logout() {
            this.authStore.logout();
            location.reload();
        },
        async coursesOnHover(courseNum, categoryName) {
            // alert(courseType)
            const res = await apiClient.get(`courses/website/courses-on-hover?SpecializationId=${courseNum}`);
            this.courses = res.data.data;
            this.showCourses = true;
            this.recordedCourses = this.courses.recordedCourses || [];
            this.onlineCourses = this.courses.onlineCourses || [];
            this.offlineCourses = this.courses.offlineCourses || [];
            this.selectedCategoryName = categoryName
        },
        backToCategories() {
            this.showCourses = false;
            this.recordedCourses = [];
            this.onlineCourses = [];
            this.offlineCourses = [];
            this.selectedCategoryName = '';
        },
        openOffcanvas() {
            this.isOffcanvasOpen = true;
            // this.isNavigating = false;
        },
        closeOffcanvas() {
            this.isOffcanvasOpen = false;
            this.isNavigating = false;
            this.history = [];
        },
        openPrograms() {
            this.showPrograms = true;
            console.log(this.showPrograms)
        },
        navigateTo(item) {
            if (item.children) {
                this.history.push({
                    items: this.currentItems,
                    title: this.currentTitle
                });
                this.currentItems = item.children;
                this.currentTitle = item.name;
            }
        },
        goBack() {
            const previous = this.history.pop();
            if (previous) {
                this.currentItems = previous.items;
                this.currentTitle = previous.title;
            } else {
                this.isNavigating = false; // Go back to main menu
            }
        },
        handleImageError(event) {
            event.target.src = require('../../assets/images/user-icon-png-22-1.jpg')
        },
    },
    watch: {
        courseType(newVal) {
            this.coursesOnHover(newVal);
        }
    },
    mounted() {
       // this.$store.dispatch('getCategories');
        // window.addEventListener("scroll", this.handleScroll);
    },
};
</script>

<style lang="scss" scoped>
.overlay-1 {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 2000;
}

.offcanvas-1 {
    -webkit-transition: -webkit-transform 0.3s ease-in-out;
    transition: -webkit-transform 0.3s ease-in-out;
    -o-transition: transform 0.3s ease-in-out;
    transition: transform 0.3s ease-in-out;
    transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;
    background-color: white;
    width: 300px;
    z-index: 2030;
    position: fixed;
    top: 0;
    height: 100%;

    &:lang(en) {
        left: 0;
        -webkit-transform: translateX(-100%);
            -ms-transform: translateX(-100%);
                transform: translateX(-100%);
    }

    &:lang(ar) {
        right: 0;
        -webkit-transform: translateX(100%);
            -ms-transform: translateX(100%);
                transform: translateX(100%);
    }
}

.user-name {
    color: #37474F;
    font-size: 16px;
    font-weight: 700;
}

.profile-img {
    border-radius: 50%;
    width: 58px;
    height: 58px;
    -ms-flex-negative: 0;
        flex-shrink: 0;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
    }
}

.user-email {
    color: #6C6C6C;
    font-size: 14px;
    font-weight: 400;
}

.fa-angle-left {
    &:lang(en) {
        -webkit-transform: scaleX(-1);
            -ms-transform: scaleX(-1);
                transform: scaleX(-1);
    }
}

.actions-section {
    border-radius: 10px;
    width: 80%;
    height: 43px;
    -ms-flex-negative: 0;
        flex-shrink: 0;
    background: #FAFAFA;

    li {
        margin-top: 10px;
    }

    a {
        color: #2EA2CE;
        font-size: 14px;
        font-weight: 400;
    }
}

.offcanvas-1.show {
    -webkit-transform: translateX(0);
        -ms-transform: translateX(0);
            transform: translateX(0);
}

.offcanvas-1 .offcanvas-body {
    -webkit-animation: fadeInAnimation ease 3s;
    animation: fadeInAnimation ease 3s;
    -webkit-animation-iteration-count: 1;
    animation-iteration-count: 1;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
}

.logout {
    &:lang(en) {
        margin-left: 10px;
    }

    &:lang(ar) {
        margin-right: 10px;
    }
}

.nav-item {
    color: #000;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 1.2rem;
}

.login-sm a {
    font-size: 16px;
    font-weight: 400;
}

.btn.back {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    padding: 5px 10px;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    border-radius: 5px;
    background: #F6F5F5;
    color: #6C6C6C;

    font-size: 12px;
    font-weight: 400;
}

.nav-link {
    &.router-link-exact-active {
        color: #2ea2ce;
        font-weight: 600;
    }
}

.list-group li {
    color: #3B3A3A;
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 10px;
    cursor: pointer;
}

.btn-primary {
    background: #206387;

    &:hover {
        background: #206387 !important;
    }

    span {
        font-size: 20px
    }
}

.special-login {
    border-top: 1px solid #206387;
    position: absolute;
    bottom: 0;
    width: 100%;
    right: 0;
    background: #fff;

    svg {
        width: 30px;
        height: 25px;
    }

    div {
        padding: 12px 17px;
    }
}

.accordion-button,
.accordion-button:not(.collapsed) {
    background: transparent;
    border: 1px solid #cbe7f6ae;
    background: #f4f4f4;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-weight: 500;
}

.accordion-button:not(.collapsed) {
    color: #349dd6;
}

.accordion-item {
    border-bottom: none;
}

.accordion-button::after {
    margin-right: auto;
    margin-left: 0;
    background-size: 1rem;
}

.test-1,
.subcontent {
    -webkit-animation: fadeInAnimation ease 3s;
    animation: fadeInAnimation ease 3s;
    -webkit-animation-iteration-count: 1;
    animation-iteration-count: 1;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;

    li {
        cursor: pointer;
    }
}

@-webkit-keyframes fadeInAnimation {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes fadeInAnimation {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}
</style>
